export const environment = {
  production: true,
  api: 'https://betaapi.govult.com',
  landingUrl: 'http://localhost:63040',
};
